export enum LabelType {
	CORE = 'Core',
	CUSTOM = 'Custom'
}

export enum PanelMode {
	ADD = 'add',
	EDIT = 'edit'
}

export interface LabelValue {
	value: string;
	dashboardVisible?: boolean;
	/** Session-only: value was added in this edit session (shown with "New" until save or reload). */
	isSessionNew?: boolean;
}

export interface Label {
	key: string;
	displayName: string;
	description?: string;
	type: LabelType;
	values: LabelValue[];
}
